"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableRowTreeLines = void 0;
const calcDepthForNode_1 = __importDefault(require("@opsbase/lib-data-element/helpers/calcDepthForNode"));
const calcIsLastItem_1 = __importDefault(require("@opsbase/lib-data-element/helpers/calcIsLastItem"));
const calcIsLastGroup_1 = __importDefault(require("@opsbase/web-ctrl-datatree/helpers/calcIsLastGroup"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const calcIsExpanded_1 = __importDefault(require("@opsbase/web-dvl/helpers/calcIsExpanded"));
const TreeLines_1 = __importDefault(require("@opsbase/web-ui/TreeLines"));
const react_1 = __importStar(require("react"));
exports.DVLTableRowTreeLines = react_1.default.memo((props) => {
    const { nodeKey, item } = props;
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const node = dt.nodesByKey.get(nodeKey);
    const isItem = !!item;
    const isExpanded = (0, calcIsExpanded_1.default)(view, node);
    const depth = (0, react_1.useMemo)(() => {
        return (0, calcDepthForNode_1.default)(node) + (isItem ? 1 : 0);
    }, [node, isItem]);
    const isLastInParent = (0, react_1.useMemo)(() => {
        return (0, calcIsLastGroup_1.default)(dt.totalCountForNode, node, view.hideEmptyGroups);
    }, [dt.totalCountForNode, node, view.hideEmptyGroups]);
    const isLastInGroup = (0, react_1.useMemo)(() => {
        return !item ? isLastInParent : (0, calcIsLastItem_1.default)(node, item);
    }, [isLastInParent, node, item]);
    const config = (0, react_1.useMemo)(() => {
        if (depth === 0)
            return [];
        if (depth === 1)
            return [isLastInGroup];
        return [isLastInParent, isLastInGroup];
    }, [isLastInGroup, isLastInParent, depth]);
    const showLineBelow = isExpanded && !isItem && dt.totalCountForNode.get(node) > 0;
    return react_1.default.createElement(TreeLines_1.default, { extend: 18, showLineBelow: showLineBelow, config: config });
});
exports.default = exports.DVLTableRowTreeLines;
